<template>
  <div class="row justify-content-center">
    <div class="col-lg-6">
      <div class="card bg-white border-0 rounded-10 mb-4">
        <div class="card-body p-4">
          <h4 class="fs-18 mb-4">Basic Toasts</h4>
          <ul class="nav nav-tabs mb-4" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="preview-tab"
                data-bs-toggle="tab"
                data-bs-target="#preview-tab-pane"
                type="button"
                role="tab"
                aria-controls="preview-tab-pane"
                aria-selected="true"
              >
                Preview
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="code-tab"
                data-bs-toggle="tab"
                data-bs-target="#code-tab-pane"
                type="button"
                role="tab"
                aria-controls="code-tab-pane"
                aria-selected="false"
              >
                Code
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div
              class="tab-pane fade show active"
              id="preview-tab-pane"
              role="tabpanel"
              aria-labelledby="preview-tab"
              tabindex="0"
            >
              <div
                class="toast show bg-white"
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
              >
                <div class="toast-header border-color">
                  <img
                    src="@/assets/images/logo-icon.png"
                    class="rounded me-2"
                    alt="..."
                  />
                  <strong class="me-auto fs-18 fw-bold text-dark">Trezo</strong>
                  <small>11 mins ago</small>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="toast"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="toast-body">
                  Hello, world! This is a toast message.
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="code-tab-pane"
              role="tabpanel"
              aria-labelledby="code-tab"
              tabindex="0"
            >
              <button
                class="btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0"
                data-clipboard-target="#basicAlertsCode"
              >
                Copy
              </button>
              <pre class="line-numbers pt-0 pb-0 ps-25 pe-25 mb-0">
<code class="language-markup" id="basicAlertsCode">
&lt;div class="toast show bg-white" role="alert" aria-live="assertive" aria-atomic="true"&gt;
&lt;div class="toast-header border-color"&gt;
&lt;img src="@/assets/images/logo-icon.png" class="rounded me-2" alt="..."&gt;
&lt;strong class="me-auto fs-18 fw-bold text-dark"&gt;Trezo&lt;/strong&gt;
&lt;small&gt;11 mins ago&lt;/small&gt;
&lt;button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"&gt;&lt;/button&gt;
&lt;/div&gt;
&lt;div class="toast-body"&gt;
Hello, world! This is a toast message.
&lt;/div&gt;
&lt;/div&gt;
</code>
</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="card bg-white border-0 rounded-10 mb-4">
        <div class="card-body p-4">
          <h4 class="fs-18 mb-4">Live Example Toasts</h4>
          <ul class="nav nav-tabs mb-4" id="myTab2" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="preview2-tab"
                data-bs-toggle="tab"
                data-bs-target="#preview2-tab-pane"
                type="button"
                role="tab"
                aria-controls="preview2-tab-pane"
                aria-selected="true"
              >
                Preview
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="code2-tab"
                data-bs-toggle="tab"
                data-bs-target="#code2-tab-pane"
                type="button"
                role="tab"
                aria-controls="code2-tab-pane"
                aria-selected="false"
              >
                Code
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent2">
            <div
              class="tab-pane fade show active"
              id="preview2-tab-pane"
              role="tabpanel"
              aria-labelledby="preview2-tab"
              tabindex="0"
            >
              <button
                type="button"
                class="btn btn-primary text-white fw-semibold py-2 px-3"
                id="liveToastBtn"
              >
                Show live toast
              </button>

              <div class="toast-container position-fixed bottom-0 end-0 p-3">
                <div
                  id="liveToast"
                  class="toast"
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                >
                  <div class="toast-header">
                    <img
                      src="@/assets/images/logo-icon.png"
                      class="rounded me-2"
                      alt="..."
                    />
                    <strong class="me-auto">Bootstrap</strong>
                    <small>11 mins ago</small>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="toast"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="toast-body">
                    Hello, world! This is a toast message.
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="code2-tab-pane"
              role="tabpanel"
              aria-labelledby="code2-tab"
              tabindex="0"
            >
              <button
                class="btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0"
                data-clipboard-target="#basicAlertsCode2"
              >
                Copy
              </button>
              <pre class="line-numbers pt-0 pb-0 ps-25 pe-25 mb-0">
<code class="language-markup" id="basicAlertsCode2">
&lt;button type="button" class="btn btn-primary text-white fw-semibold py-2 px-3" id="liveToastBtn"&gt;Show live toast&lt;/button&gt;

&lt;div class="toast-container position-fixed bottom-0 end-0 p-3"&gt;
&lt;div id="liveToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true"&gt;
&lt;div class="toast-header"&gt;
&lt;img src="@/assets/images/logo-icon.png" class="rounded me-2" alt="..."&gt;
&lt;strong class="me-auto"&gt;Bootstrap&lt;/strong&gt;
&lt;small&gt;11 mins ago&lt;/small&gt;
&lt;button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"&gt;&lt;/button&gt;
&lt;/div&gt;
&lt;div class="toast-body"&gt;
Hello, world! This is a toast message.
&lt;/div&gt;
&lt;/div&gt;
&lt;/div&gt;
</code>
</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import Prism from "prismjs";
import "prismjs/themes/prism.min.css";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Toasts",
  setup() {
    onMounted(() => {
      Prism.highlightAll();

      const toastTrigger = document.getElementById("liveToastBtn");
      const toastLiveExample = document.getElementById("liveToast");

      if (toastTrigger && toastLiveExample) {
        const toastBootstrap = (
          window as any
        ).bootstrap.Toast.getOrCreateInstance(toastLiveExample);
        toastTrigger.addEventListener("click", () => {
          toastBootstrap.show();
        });
      }
    });
  },
});
</script>
